var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentHourglassPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7002_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.34315 0.169434C1.31893 0.169434 0.491455 0.986022 0.491455 1.99676C0.491455 3.00751 1.31893 3.82409 2.34315 3.82409V4.45224C2.34315 6.87345 3.32108 9.19759 5.05704 10.9107L8.98032 14.7881L5.05704 18.6654C3.32108 20.3786 2.34315 22.7027 2.34315 25.1239V25.7521C1.31893 25.7521 0.491455 26.5686 0.491455 27.5794C0.491455 28.5901 1.31893 29.4067 2.34315 29.4067H4.19484H19.0084H20.8601C21.8843 29.4067 22.7118 28.5901 22.7118 27.5794C22.7118 26.5686 21.8843 25.7521 20.8601 25.7521V25.1239C20.8601 22.7027 19.8822 20.3786 18.1462 18.6654L14.2229 14.7881L18.152 10.9107C19.888 9.19759 20.8659 6.87345 20.8659 4.45224V3.82409C21.8901 3.82409 22.7176 3.00751 22.7176 1.99676C22.7176 0.986022 21.8901 0.169434 20.8659 0.169434H19.0084H4.19484H2.34315ZM17.1567 25.1239V25.7521H6.04654V25.1239C6.04654 23.6678 6.63098 22.2744 7.67256 21.2465L11.6016 17.3749L15.5307 21.2523C16.5723 22.2801 17.1567 23.6735 17.1567 25.1296V25.1239Z",
    fill: "#662D91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7002_220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2203,
    height: 29.2373,
    fill: "white",
    transform: "translate(0.491455 0.169922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHourglassPurple);
export default __webpack_public_path__ + "static/media/payment_hourglass_purple.ca7340dffd688a0e43f2b510e1863cbf.svg";
export { ForwardRef as ReactComponent };